// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ListItemIcon":"bby_a bhh_kb","ListItemIcon--empty":"bby_b bhh_fj"};